export enum ProductType {
  Announcment = 1,
  CvDatabaseAccess = 2,
  SliderBanner = 9,
  CvBox = 14,
  Branding = 18,
}
